import React, {useEffect, useState} from "react";
import {Button} from "../../../../index";
import {useViewerStore} from "../../../../../store/store";
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import {Flex, Input} from "antd";
import {generateDirectLayout} from "../../Drawer/Drawer-Sections/5-Reports-Section/Reports/Direct_Layout";

interface DirectLayoutInputPopupProps {
    onSubmitForm?: (annualUsage: number, financePartnerProduction: number) => void;
    boxUpload?: boolean;
}

const DirectLayoutInputPopup = (props: DirectLayoutInputPopupProps) => {

    const onSubmitForm = props?.onSubmitForm;
    const boxUpload = props?.boxUpload;

    const [annualUsageInput, setAnnualUsageInput] = useState<number>(0);
    const [financePartnerProdInput, setFinancePartnerProductionInput] = useState<number>(0);
    const {annualUsage, epcEstimatedProduction} = useViewerStore(state => state);

    const [pdfGenerationStatus, setPdfGenerationStatus] = useState("default");

    useEffect(() => {
        if (annualUsage && Number(annualUsage) >= 0) setAnnualUsageInput(annualUsage);
        if (Number(epcEstimatedProduction) >= 0) setFinancePartnerProductionInput(Number(epcEstimatedProduction) / 1000);
    }, []);
    
    const submitForm = async () => {
        //validate inputs
        if (annualUsageInput === 0) {
            alert('Please enter the annual usage');
            return
        } else if (financePartnerProdInput === 0){
            alert('Please enter the finance partner production');
            return
        }

        if (onSubmitForm) {
            onSubmitForm(annualUsageInput, financePartnerProdInput);
            return
        }
        setPdfGenerationStatus('generating');
        const viewerState = useViewerStore.getState();
        const pdf = await generateDirectLayout(viewerState, annualUsageInput, financePartnerProdInput);
        if (pdf) {
            const sfidString = sessionStorage.getItem('SalesForceId');
            pdf.save(`oneDRAW_Direct_Layout_${sfidString}.pdf`); // Set the desired file name and trigger download
            setPdfGenerationStatus('success');
        } else {
            setPdfGenerationStatus('error');
        }
    };

    return (<>

        {

            pdfGenerationStatus === 'success' ? <Flex vertical justify={'center'} align={'center'}>
                <p className="report-text">Direct Layout PDF Generated Successfully</p>
                <img
                    src={completedIcon}
                    alt={"Completed Icon"}
                    width={50}
                    height={50}
                />
            </Flex> : pdfGenerationStatus === 'error' ? <Flex vertical justify={'center'} align={'center'} gap={5}>
                <p>Direct Layout PDF Generation Failed</p>
                <img
                    src={errorIcon}
                    alt={"Error Icon"}
                    width={50}
                    height={50}
                />
            </Flex> : pdfGenerationStatus === 'generating' ? <Flex justify={'center'} align={'center'} gap={10}>
                <span className="loader-icon-spinner"></span>
                <p>Generating Direct Layout PDF</p>

            </Flex> : <div className={'treeForm'}>
                <label htmlFor="annualUsageInput">Enter Annual Usage : </label>
                <Input
                    id={"annualUsageInput"}
                    type={"number"}
                    value={annualUsageInput}
                    onChange={(e) => setAnnualUsageInput(Number(e.target.value))}
                    placeholder={"Enter Value Here in kWh"}
                    name="annualUsage"
                />
                <br/>
                <label htmlFor="financePartnerProdInput">Enter Finance Partner Production
                    : </label>
                <Input
                    id={"financePartnerProdInput"}
                    type={"number"}
                    value={financePartnerProdInput}
                    onChange={(e) => setFinancePartnerProductionInput(Number(e.target.value))}
                    placeholder={"Enter Value Here in kWh"}
                    name="financePartnerProduction"
                />


                <br/>
                <Button
                    id={"submitDirectLayoutForm"}
                    onClick={submitForm}
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                >
                    {boxUpload ? "Upload reports to Box" : "Download Direct Layout"}
                </Button>

            </div>


        }

    </>)
}

export default DirectLayoutInputPopup